module.exports = __webpack_public_path__ + "static/img/sign.5cc82b66.png";